// GENERATED from ez-tree preset "Ash Medium" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AshMedium_KIND_ID = "ezTree_AshMedium";

export const AshMediumKind = new SceneryKindDef({
	id: "ezTree_AshMedium",
	name: "Ash Medium",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchAngle1": 48,
		"branchAngle2": 75,
		"branchChildren1": 4,
		"branchChildren2": 3,
		"branchGnarliness0": 0.03,
		"branchGnarliness1": 0.25,
		"branchGnarliness2": 0.2,
		"branchGnarliness3": 0.09,
		"branchLength0": 43.47,
		"branchLength1": 27.14,
		"branchLength2": 9.51,
		"branchLength3": 4.6,
		"branchRadius0": 2,
		"branchRadius1": 0.63,
		"branchRadius2": 0.76,
		"branchSections1": 8,
		"branchSections2": 6,
		"branchSections3": 4,
		"branchSegments0": 12,
		"branchStart1": 0.23,
		"branchStart2": 0.33,
		"branchStart3": 0,
		"branchTwist0": 0.09,
		"branchTwist1": -0.07,
		"leafCount": 16,
		"leafSize": 2.67,
		"leafSizeVariance": 0.72,
		"leafAngle": 55,
		"leafType": "ash",
		"barkTint": 13552830,
		"barkTextureScaleX": 0.5,
		"barkTextureScaleY": 5,
		"targetHeight": 19.8,
	},
	footprintRadiusRatio: 0.483,
});
